module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "calibre8",
    attrs: {
      "id": "filepos21523"
    }
  }, [_c('img', {
    staticClass: "calibre3",
    attrs: {
      "alt": "images",
      "src": "Images/00015.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("If you are a sewing ‘newbie’ the thought of deviating from a pattern may seem like a crazy thing to do, but it’s actually very easy to make pattern modifications to suit you (or your outfit!). In their simplest form, bags are a front, a back and a couple of handles. But you can jazz up even a basic bag by changing its size, adding a pocket, inserting a zip or a snap, or changing the handles, for example. Here you will find guidance on changing the size of the bag as the first step to modifying a pattern. Because bag making is less complicated than dressmaking you’ll find that it’s far more forgiving if you haven’t quite got the measurements 100 per cent right. In fact, half the fun of bag making is that you can often make it up as you go along. I do it all the time!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("INCREASING THE SIZE")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("• First decide how much larger you would like your finished bag to be. Take that measurement, divide it in half and add that halved measurement all around the edge of the bag pattern piece(s). Say, for example, you want your finished bag to be 10cm (4in) larger overall; you would add a 5cm (2in) margin all around the outside of the bag pattern piece(s). Always remember to add on your seam allowance if you haven’t already.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("• N.B. If your pattern piece is marked with a ‘place on fold’ instruction you will need to add your margin around all pattern edges except the edge where you are instructed to ‘place on fold’.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("DECREASING THE SIZE")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("• First decide how much smaller you would like your finished bag to be. Take that measurement, divide it in half and subtract that halved measurement from all around the edge of the bag pattern piece(s). Say, for example, you want your finished bag to be 10cm (4in) smaller overall; you would subtract a 5cm (2in) margin from all around the inside of the bag pattern piece(s), remembering to include your seam allowance if you haven’t already.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_vm._v("• N.B. If your pattern piece is marked with a ‘place on fold’ instruction you will need to subtract your margin from around all pattern edges except the edge where you are instructed to ‘place on fold’.")]), _vm._v(" "), _c('div', {
    staticClass: "mbppagebreak",
    attrs: {
      "id": "calibre_pb_4"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c6bdf4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/3_Beautiful_-or_all_Reasons_split_004.vue
// module id = 69
// module chunks = 0